import { memo, useCallback } from 'react'
import { FloaterSize } from '../../../../../../constants/floaters'
import { RoomView } from '../../../../../../state/modals'
import {
    closeWhiteboard,
    openWhiteboard,
} from '../../../../../../state/state.whiteboard'
import i18n from '../../../../../../utilities/i18n'
import { useRoomSelector } from '../../../../../Hooks/useRoomAppState'
import { useUserSelector } from '../../../../../Hooks/useUser'
import { useWhiteboardSelector } from '../../../../../Hooks/useWhiteboard'
import FlexGrid from '../../../../../common/FlexGrid'
import Empty from '../../../../Empty'
import ChatActionsBar from '../../../ActionsBar'
import ChatHeader from '../../../ChatHeader'
import { ViewProps, getLeftStyles } from '../common/helpers'
import { gridRootStyles, rootStyles, videoGridStyles } from '../common/styles'

const BannedOrKicked = (props: ViewProps) => {
    const {
        id,
        size,
        roomView,
        // height,
        // width,
        vertical,
        fullWindow,
        surrogateName,
    } = props
    const isLounge = useRoomSelector(id, 'isLounge')
    const isWhiteboardOpen = useWhiteboardSelector('open')

    const banned = useUserSelector(id, 'banned')
    const isKicked = useUserSelector(id, 'isKicked')
    const isModel = useUserSelector(id, 'isModel') || isLounge
    const name = useUserSelector(id, 'name')

    const modelName = !isLounge ? name : surrogateName

    const isPM = roomView === RoomView.PM
    const isFullscreen = size === FloaterSize.Fullscreen

    const showVideo = isPM ? props.showVideo : true

    const noAccessMessage = banned
        ? i18n.t('rooms.banned')
        : isKicked
          ? i18n.t('rooms.kicked')
          : ''
    const leftStyles = getLeftStyles({
        vertical,
        banned,
        isLounge,
        isModel,
    })

    const onToggleWhiteboard = useCallback(() => {
        if (isWhiteboardOpen) {
            closeWhiteboard()
        } else {
            openWhiteboard(modelName)
        }
    }, [isWhiteboardOpen, modelName])

    const Header = (
        <ChatHeader
            id={id}
            preview={size < FloaterSize.Fullscreen}
            showBadge={isPM && !showVideo}
            pm={isPM}
            room
        />
    )

    const ActionsBar = (
        <ChatActionsBar
            id={id}
            roomView={roomView}
            fullWindow={fullWindow}
            onWhiteboard={onToggleWhiteboard}
            floating
        />
    )

    return (
        <div css={rootStyles}>
            {/* [not fullscreen] ChatHeader is above video */}
            {((!vertical && isFullscreen) ||
                (!isFullscreen && size > FloaterSize.Small)) &&
                Header}
            <FlexGrid
                overrides={gridRootStyles}
                direction={!vertical ? 'row' : 'column'}
                wrap={!vertical ? 'wrap' : 'nowrap'}
                key={id}
            >
                {isModel && (
                    <FlexGrid
                        overrides={videoGridStyles}
                        style={{
                            maxWidth: leftStyles === 'auto' ? null : leftStyles,
                            flexBasis: leftStyles,
                        }}
                        data-testid="Video__Section"
                    >
                        {/* [landscape] chat actions bar is above video */}
                        {!vertical && !fullWindow && isFullscreen && ActionsBar}
                        {/* in a model's room and allowed to view her stream or in the lounge */}
                        {/* [portrait] ChatHeader is below video */}
                        {!!vertical && isFullscreen && Header}
                    </FlexGrid>
                )}
                {/* [portrait] leave the chat actions so we can navigate to PMs and ask what's up */}
                {vertical && !fullWindow && ActionsBar}
                <Empty
                    before={noAccessMessage}
                    after={i18n.t('rooms.viewableRoom')}
                />
            </FlexGrid>
        </div>
    )
}

export default memo(BannedOrKicked)
